<template>
  <div>
    <div class="row">
      <div class="col-11">
        <SectionTitle
          icon="fas fa-info-circle"
          content="Salud"
          container-class="tag-badge-main-info mt-5 mb-4"
        />
      </div>
     <div v-if="canDelete && !disabled" class="col-1 d-flex justify-content-end align-items-center">
        <action-button
          i="far fa-times pointer icon-right color-primary-3 font-28"
          class="px-1 mr-2 "
          @click="showItem(items)"
        />
      </div>
    </div>
     <div class="d-flex flex-column">
      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
           <div class="question-width">
              <b class="mb-0">
             El estudiante presenta una condición médica que requiere de cuidado especializado durante el horario escolar. Este servicio se tiene que solicitar anualmente. Para ello, los padres deberán presentar, en cada revisión de PEI, el formulario Referido por médico por condición de salud.
            </b>
           </div>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <custom-radio
                v-model="value.studentNeedSpecialAttention"
                id="studentNeedSpecial"
                :change-event="onChangestudentNeedSpecial"
                name="studentNeedSpecial"
                label=""
                is-question-list
                :options="studentNeedSpecialOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
             El estudiante presenta una discapacidad moderada y severa que le impide atender sus necesidades médicas, aun cuando se le provea de claves visuales o instrucciones dirigidas.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <custom-radio
                v-model="value.studentHasImpediment"
                id="studentHasImpediment"
                :change-event="onChangestudentHasImpediment"
                name="studentHasImpediment"
                label=""
                :options="studentHasImpedimentOptions"
                is-question-list
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
           <div class="question-width">
              <b class="mb-0">
             El estudiante presenta conductas/emociones inapropiadas que afectan o podrían afectar su progreso académico y que requieren de un plan de intervención donde un adulto apoye su plan de apoyo conductual o emocional.
            </b>
           </div>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <custom-radio
                v-model="value.studentInappropriateConduct"
                id="studentInappropiateConduct"
                :change-event="onChangeStudentInappropiateConduct"
                name="studentInappropiateConduct"
                label=""
                is-question-list
                :options="yesOrNotOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>


      <div class="m-2 pt-3">
        <div class="row">
            <div v-for="(item, index) in peiServiceNeedsHealthType" :key="index" class="col-3 p-2">
              <CheckBox
                v-model="item.value"
                disabled
                class="font-weight-light text-md-nowrap"
                :text="item.name"
                :disabled="disabled"
              />
            </div>
        </div>
      </div>

      <div class="mt-4 pb-4 pr-2">
        <div>Comentarios Adicionales:</div>
        <CustomTextArea
          id="studentHealtComments"
          v-model="value.comments" 
          class="mt-2"
          :placeholder="'Escribe un comentario'"
          :maxlength="3000"
          show-char-count
          :count-classes="['d-block text-right']"
          :rows="5"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>

</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import CustomRadio from '@/components/common/CustomRadioBorder';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import CheckBox from 'CheckBox';
import peiServiceNeeds from "@/utils/constants/pei/peiServiceNeeds.js";
import Error from "@/components/common/Error";

export default {
  name: "Health",
  components: {
    SectionTitle,
    CustomRadio,
    CustomTextArea,
    ActionButton,
    CheckBox,
    Error
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    validable: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    items:{
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
       studentHasImpedimentOptions: [
        { label: 'Si', value: true, check: false},
        { label: 'No', value: false, check: false },
      ],
      studentNeedSpecialOptions: [
        { label: 'Si', value: true, check: false},
        { label: 'No', value: false, check: false },
      ],
      yesOrNotOptions: [
        { label: 'Si', value: true, check: false},
        { label: 'No', value: false, check: false },
      ],
      alternativesSelected:Object.assign([],this.items),
      peiServiceNeedsHealthType : [
         {
            id:peiServiceNeeds.healthCatheterization,
            name:"Cateterización",
            value:false
        },
        {
            id:peiServiceNeeds.healthColostomy,
            name:"Colostomía",
            value:false
        },
         {
            id:peiServiceNeeds.healthGastrostomy,
            name:"Gastrostomía",
            value:false
        },
        {
            id:peiServiceNeeds.healthDiabetes,
            name:"Diabetes",
            value:false
        },
        {
            id:peiServiceNeeds.healthMedication,
            name:"Medicación",
            value:false
        },
        {
            id:peiServiceNeeds.MedicationAdministration,
            name:"Medicación",
            value:false
        },
         {
            id:peiServiceNeeds.healthAnxiety,
            name:"Ansiedad Severa",
            value:false
        },
        {
            id:peiServiceNeeds.healthsupportForHealthNeeds,
            name:"Apoyo conductual a la necesidad de salud",
            value:false
        },
      ],
      alternativesHealth:[],
    };
  },
  mounted(){
    this.filterByAlternativesHealtSelected();
    this.setValuesIfExist();
  },
  methods:{
    setValuesIfExist(){
      // fill the checkbox yes or not option in frontend with the db result.
      this.setCheckValue(this.value.studentInappropriateConduct, this.yesOrNotOptions);
      this.setCheckValue(this.value.studentHasImpediment, this.studentHasImpedimentOptions);
      this.setCheckValue(this.value.studentNeedSpecialAttention, this.studentNeedSpecialOptions);
     
      this.studentHealthComments = this.value.comments != null ?
      this.value.comments : this.studentHealthComments;
      this.alternativesHealth =  this.alternativesHealth;
    },
    setCheckValue(value, options){
      if (value != null) {
        let hasImpediment = options.find(r => r.value === value);
        hasImpediment.check = true;
      }
    },
    showItem(){
      this.$emit('delete', this.alternativesHealth)
    },
    filterByAlternativesHealtSelected(){
      let result = this.peiServiceNeedsHealthType.filter((item)=> {

      let obj = this.alternativesSelected.find((item2) =>{
        if(item2.id === item.id){
          item.value=true
          return true
        }
      });
        return obj !== undefined;
      });
      this.alternativesHealth= result
    },
    onChangestudentHasImpediment(item) {
      this.value.studentHasImpediment = item.value;
    },
    onChangestudentNeedSpecial(item) {
       this.value.studentNeedSpecialAttention = item.value;
    },
    onChangeStudentInappropiateConduct(item) {
       this.value.studentInappropriateConduct = item.value;
    },
  }
};
</script>
<style scoped>

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}
.question-width{
      width: 80%;
}
</style>
